<section>
  <div class="row">
    <div class="mb-2">
      <form class="needs-validation" novalidate [formGroup]="formFormat">
        <div class="row">
          <div class="col field-company">
            <app-custom-autocomplete formControlName="companyId" [labelText]="'Compañía'" [list]="listCompany"
              [required]="true" [recovery]="true" (onChangeSelect)="getCompany($event, true)">
            </app-custom-autocomplete>
          </div>
          <div class="col field-format">
            <app-custom-autocomplete formControlName="code" [labelText]="'Formato'" [list]="listFormat"
              [required]="true" [recovery]="true" (onChangeSelect)="getFormatByCode($event)">
            </app-custom-autocomplete>
          </div>
          <div class="col field-company">
            <app-custom-autocomplete formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
              (onChangeSelect)="getBranch($event)">
            </app-custom-autocomplete>
          </div>
          <div class="col field-company">
            <app-custom-autocomplete formControlName="enterpriseId" [labelText]="'Empresa'" [list]="listEnterprises"
              (onChangeSelect)="getEnterprise($event)">
            </app-custom-autocomplete>
          </div>
          <div class="col field-consecutive">
            <app-custom-input-number formControlName="consecutive" [labelText]="'Número'" [required]="true"
              (onChangeNumber)="changeConsecutive()"></app-custom-input-number>
          </div>
          <div class="col field-view-format d-flex align-items-end">
            <app-custom-button [title]="'Ver Formato'" [icon]="'pi pi-external-link'" [severity]="'success'"
              (onClick)="goToFormat()"></app-custom-button>
          </div>
          <div class="col field-download-pdf d-flex align-items-end">
            <app-custom-button [title]="'Descargar PDF'" [icon]="'pi pi-file-pdf'" [severity]="'danger'"
              [disabled]="!(isPdfFormat() && isPrincipalCompany) || generatingPdf"
              (onClick)="downloadPreviewPdf()"></app-custom-button>
          </div>
          <div class="col field-import d-flex justify-content-end align-items-end mt-2">
            <app-custom-button [label]="'Importar'" [severity]="'primary'" [variant]="undefined"
              (onClick)="importFormat()"></app-custom-button>
          </div>
          <div class="col field-export d-flex justify-content-end align-items-end mt-2">
            <app-custom-button [label]="'Exportar'" [severity]="'danger'" [variant]="undefined"
              (onClick)="exportFormatChanges()"></app-custom-button>
          </div>

        </div>
      </form>
      <div class="row mt-2" *ngIf="generatingPdf">
        <p class="mb-2"><b>Generando PDF...</b></p>
        <app-custom-progress-bar [show]="true" [heightProgress]="'0.8rem'"></app-custom-progress-bar>
      </div>
      <form class="needs-validation" novalidate [formGroup]="formFormatDetail">
        <hr class="my-2">
        <div class="row">
          <div class="col field-name">
            <app-custom-input-text formControlName="name" [labelText]="'Nombre'"></app-custom-input-text>
          </div>
          <div class="col field-visible d-flex align-items-end mb-1">
            <app-custom-checkbox formControlName="visible" [labelText]="'Visible'"
              (onChangeCheckBox)="changeVisible()"></app-custom-checkbox>
          </div>
          <div class="col field-font-size">
            <app-custom-input-number formControlName="fontSize" [labelText]="'FontSize'"
              (onChangeNumber)="changeFontSize()"></app-custom-input-number>
          </div>
          <div class="col field-bold">
            <app-custom-select formControlName="bold" [labelText]="'Bold'" [list]="listBold"
              (onChangeSelect)="changeBold()"></app-custom-select>
          </div>
          <div class="col field-alignment">
            <app-custom-select formControlName="alignment" [labelText]="'Alignment'" [list]="listAlignment"
              (onChangeSelect)="changeAlignment()"></app-custom-select>
          </div>
          <div class="col field-border">
            <app-custom-select formControlName="border" [labelText]="'Border'" [list]="listBorder"
              (onChangeSelect)="changeBorder()"></app-custom-select>
          </div>
          <div class="col field-x">
            <app-custom-input-decimal formControlName="left" [labelText]="'Eje X'" [maxFractionDigits]="4"
              (onChangeNumber)="changeLeft()"></app-custom-input-decimal>
          </div>
          <div class="col field-y">
            <app-custom-input-decimal formControlName="top" [labelText]="'Eje Y'" [maxFractionDigits]="4"
              (onChangeNumber)="changeTop()"></app-custom-input-decimal>
          </div>
          <div class="col field-width">
            <app-custom-input-decimal formControlName="width" [labelText]="'Ancho'" [maxFractionDigits]="4"
              (onChangeNumber)="changeWidth()"></app-custom-input-decimal>
          </div>
          <div class="col field-height">
            <app-custom-input-decimal formControlName="height" [labelText]="'Altura'" [maxFractionDigits]="4"
              (onChangeNumber)="changeHeight()"></app-custom-input-decimal>
          </div>
          <div class="col field-text">
            <app-custom-input-text id="text" formControlName="text" [labelText]="'Texto'"
              (onChangeText)="changeText()"></app-custom-input-text>
          </div>
          <div class="col field-format">
            <app-custom-input-text formControlName="printFormat" [labelText]="'Formato'"
              (onChangeText)="changePrintFormat()"></app-custom-input-text>
          </div>
          <div class="col field-format-type" *ngIf="formatPreInvoicing == formatModel().code">
            <app-custom-select formControlName="formatType" [labelText]="'Formato'" [list]="listFormatType"
              (onChangeSelect)="changeFormatType($event)"></app-custom-select>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="ui-panel" [hidden]="hiddenView">
    <label>Zoom: <b id="zoomVal">100</b>%</label><br>
    <input type="range" id="zoomSlider" min="0.2" max="3" step="0.1" value="1" (input)="onZoomChange($event)">
  </div>

  <div class="row" id="container-format-2">
    <div id="viewport">
      <div class="canvas-container" id="spacer" [hidden]="hiddenView">
        <div id="canvas">
          <!-- Formato Imprimir Hoja de Vida Simple -->
          <app-print-equipment-logbook-valued *ngIf="formatValuedEquipmentLogbook == formatModel().code"
            id="preview-equipment-logbook-valued" [companyId]="companyId" [formatModel]="formatModel()"
            [exportFormat]="exportFormat" [equipmentLogbookPrintModel]="equipmentLogbookPrintModel" [editFormat]="true"
            [focusText]="focusText" [formatDetail]="formatDetailInput" (emitFormatDetail)="getFormatDetail($event)"
            (finishLoadingPrintMaintenanceOrder)="finishLoading($event)">
          </app-print-equipment-logbook-valued>

          <!-- Formato Imprimir Hoja de Vida Simple -->
          <app-print-equipment-logbook-simple *ngIf="formatSimpleEquipmentLogbook == formatModel().code"
            id="preview-equipment-logbook-simple" [companyId]="companyId" [formatModel]="formatModel()"
            [exportFormat]="exportFormat" [equipmentLogbookPrintModel]="equipmentLogbookPrintModel" [editFormat]="true"
            [focusText]="focusText" [formatDetail]="formatDetailInput" (emitFormatDetail)="getFormatDetail($event)"
            (finishLoadingPrintMaintenanceOrder)="finishLoading($event)">
          </app-print-equipment-logbook-simple>

          <!-- Formato Prefactura - Vista Previa -->
          <div *ngIf="formatPreInvoicing == formatModel().code">
            <app-preview-pre-invoicing *ngIf="formatPreInvoicing == formatModel().code" id="printComponent"
              [hidden]="!finishLoadingPrint" [editFormat]="true" [companyId]="companyId" [formatModel]="formatModel()"
              [preinvoicingPrintModel]="preinvoicingPrintModel" [exportFormat]="exportFormat" [focusText]="focusText"
              [formatDetail]="formatDetailInput" [isGeneralFormat]="isGeneralFormat"
              (emitFormatDetail)="getFormatDetail($event)"
              (finishLoadingPrint)="finishLoading($event)"></app-preview-pre-invoicing>
          </div>

          <!-- Formato Imprimir Factura -->
          <app-print-invoice *ngIf="formatInvoice == formatModel().code" id="preview-invoice" [companyId]="companyId"
            [formatModel]="formatModel()" [invoiceModels]="invoicesPrintModel" [editFormat]="true"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-invoice>

          <!-- Formato Imprimir Nota -->
          <app-print-note *ngIf="formatNote == formatModel().code" id="printComponent" [companyId]="companyId"
            [notePrintModel]="notePrintModel" [exportFormat]="exportFormat" [focusText]="focusText"
            [formatModel]="formatModel()" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-note>

          <!-- Formato Imprimir Solicitud de Nota -->
          <app-print-request-note *ngIf="formatRequestNote == formatModel().code" id="printComponent"
            [companyId]="companyId" [requestNotePrintModel]="requestNotePrintModel" [exportFormat]="exportFormat"
            [focusText]="focusText" [formatModel]="formatModel()" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-request-note>

          <!-- Formato Imprimir Remisión -->
          <app-print-remission *ngIf="formatRemission == formatModel().code" id="preview-remission"
            [companyId]="companyId" [formatModel]="formatModel()" [remissionModel]="remissionPrintModel"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            [swIncludeStore]="swIncludeStore" (emitFormatDetail)="getFormatDetail($event)"
            (finishLoadingPrint)="finishLoading($event)">
          </app-print-remission>


          <!-- Formato Imprimir Entradas Inventario -->
          <div *ngIf="formatInventoryEntry == formatModel().code">
            <app-print-inventory-entry id="preview-inventory-entry" [hidden]="!finishLoadingPrint"
              [companyId]="companyId" [formatModel]="formatModel()" [inventoryEntryModel]="inventoryEntryModel"
              [editFormat]="true" [exportFormat]="exportFormat" [focusText]="focusText"
              [formatDetail]="formatDetailInput" (emitFormatDetail)="getFormatDetail($event)"
              (finishLoadingPrint)="finishLoading($event)">
            </app-print-inventory-entry>
          </div>

          <!-- Formato Imprimir Salidas Inventario -->
          <app-print-inventory-output *ngIf="formatInventoryOutput == formatModel().code" id="preview-inventory-output"
            [formatModel]="formatModel()" [inventoryOutputPrintModel]="inventoryOutputPrintModel"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-inventory-output>

          <!-- Formato Imprimir Traslado Inventario -->
          <app-print-inventory-transfer *ngIf="formatInventoryTransfer == formatModel().code"
            id="preview-inventory-transfer" [companyId]="companyId" [formatModel]="formatModel()"
            [inventoryTransferModel]="inventoryTransferPrintModel" [exportFormat]="exportFormat" [focusText]="focusText"
            [formatDetail]="formatDetailInput" [editFormat]="true" (emitFormatDetail)="getFormatDetail($event)"
            (finishLoadingPrint)="finishLoading($event)">
          </app-print-inventory-transfer>

          <!-- Formato Imprimir Remisión Venta -->
          <app-print-sales-remission *ngIf="formatSalesRemission == formatModel().code" id="preview-sales-remission"
            [formatModel]="formatModel()" [salesRemissionPrintModel]="salesRemissionPrintModel"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-sales-remission>

          <!-- Formato Imprimir Traslados Almacen Taller -->
          <app-print-transfer-store-workshop *ngIf="formatTransferStoreWorkshop == formatModel().code"
            id="preview-transfer-store-workshop" [companyId]="companyId" [reloadPrint]="reloadPrint"
            [transferStoreWorkshopPrintModel]="transferStoreWorkshopPrintModel" [editFormat]="true"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-transfer-store-workshop>

          <!-- Formato Imprimir Traslados Taller Almacen -->
          <app-print-transfer-workshop-store *ngIf="formatTransferWorkshopStore == formatModel().code"
            id="preview-transfer-workshop-store" [companyId]="companyId" [reloadPrint]="reloadPrint"
            [transferWorkshopStorePrintModel]="transferWorkshopStorePrintModel" [editFormat]="true"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-transfer-workshop-store>

          <!-- Formato Imprimir Cuenta de Cobro -->
          <app-print-charge-account *ngIf="formatChargeAccount == formatModel().code" id="preview-charge-account"
            [formatModel]="formatModel()" [companyId]="companyId" [chargeAccountModels]="chargeAccountsPrintModel"
            [editFormat]="true" [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-charge-account>

          <!-- Formato Imprimir Cotización -->
          <app-print-quotation *ngIf="formatQuotation == formatModel().code" id="printComponent" [companyId]="companyId"
            [formatModel]="formatModel()" [quotationPrintContract]="quotationPrintContract"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)" (finishLoadingPrint)="finishLoading($event)">
          </app-print-quotation>

          <!-- Formato Imprimir Pedido -->
          <app-print-order *ngIf="formatOrder == formatModel().code" id="preview-order" [companyId]="companyId"
            [reloadPrint]="reloadPrint" [orderPrintModel]="orderPrintModel" [exportFormat]="exportFormat"
            [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-order>

          <!-- Formato Imprimir Predevoluciones -->
          <app-print-predevolution *ngIf="formatPredevolution == formatModel().code" id="print-predevolution"
            [companyId]="companyId" [predevolutionPrintModel]="devolutionPrintModel" [exportFormat]="exportFormat"
            [reloadPrint]="reloadPrint" [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            [swIncludeStore]="swIncludeStore" [printOnlyQuantity]="true" [printOnlyStore]="true"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-predevolution>


          <!-- Formato Imprimir Devolución -->
          <app-print-devolution *ngIf="formatDevolution == formatModel().code" id="print-devolution"
            [companyId]="companyId" [reloadPrint]="reloadPrint" [devolutionPrintModel]="devolutionPrintModel"
            [exportFormat]="exportFormat" [swIncludeStore]="swIncludeStore" [focusText]="focusText"
            [formatDetail]="formatDetailInput" [editFormat]="true" (emitFormatDetail)="getFormatDetail($event)">
          </app-print-devolution>

          <!-- Formato Imprimir Servicios -->
          <app-print-service *ngIf="formatService == formatModel().code" id="printComponent" [companyId]="companyId"
            [reloadPrint]="reloadPrint" [servicePrintModel]="servicePrintModel" [exportFormat]="exportFormat"
            [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-service>

          <!-- Formato Imprimir Suspension -->
          <app-print-suspension *ngIf="formatSuspension == formatModel().code" id="preview-suspension"
            [reloadPrint]="reloadPrint" [companyId]="companyId" [suspensionPrintModel]="suspensionPrintModel"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-suspension>

          <!-- Formato Imprimir entre obras -->
          <app-print-transfer-construction-site *ngIf="formatTransferConstructionSite == formatModel().code"
            id="preview-transfer-construction-site" [companyId]="companyId" [formatModel]="formatModel()"
            [transferConstructionSitePrintModel]="transferConstructionSitePrintModel" [editFormat]="true"
            [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-transfer-construction-site>

          <!-- Formato Imprimir Documento Soporte -->
          <app-print-document-support *ngIf="formatDocumentSupport == formatModel().code" id="preview-document-support"
            [formatModel]="formatModel()" [companyId]="companyId" [documentSupportModel]="documentSupportPrintModel"
            [printDocument]="false" [editFormat]="true" [exportFormat]="exportFormat" [focusText]="focusText"
            [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-document-support>

          <!-- Formato Imprimir Pedido Interno -->
          <div *ngIf="formatInternalOrder == formatModel().code">
            <app-print-internal-order id="preview-internal-order" [hidden]="!finishLoadingPrint" [companyId]="companyId"
              [formatModel]="formatModel()" [internalOrderModel]="internalOrderModel" [editFormat]="true"
              [exportFormat]="exportFormat" [focusText]="focusText" [formatDetail]="formatDetailInput"
              (emitFormatDetail)="getFormatDetail($event)">
            </app-print-internal-order>
          </div>

          <!-- Formato Imprimir Orden de Compra -->
          <app-print-purchase-order *ngIf="formatPurchaseOrder == formatModel().code" id="printComponent"
            [companyId]="companyId" [exportFormat]="exportFormat" [focusText]="focusText"
            [formatDetail]="formatDetailInput" [formatModel]="formatModel()"
            [purchaseOrderPrint]="purchaseOrderPrintModel" (emitFormatDetail)="getFormatDetail($event)"
            [editFormat]="true">
          </app-print-purchase-order>

          <!-- Formato Imprimir Entradas Subalquiler -->
          <div *ngIf="formatSubrentalEntry == formatModel().code">
            <app-print-subrental-entry id="preview-subrental-entry" [hidden]="!finishLoadingPrint"
              [companyId]="companyId" [formatModel]="formatModel()" [subrentalEntryModel]="subrentalEntryPrintModel"
              [editFormat]="true" [exportFormat]="exportFormat" [focusText]="focusText"
              [formatDetail]="formatDetailInput" (emitFormatDetail)="getFormatDetail($event)"
              (finishLoadingPrint)="finishLoading($event)">
            </app-print-subrental-entry>
          </div>

          <!-- Formato Imprimir Salidas Subalquiler -->
          <div *ngIf="formatSubrentalOutput == formatModel().code">
            <app-print-subrental-output id="preview-subrental-output" [hidden]="!finishLoadingPrint"
              [companyId]="companyId" [formatModel]="formatModel()" [subrentalOutputModel]="subrentalOutputPrintModel"
              [editFormat]="true" [exportFormat]="exportFormat" [focusText]="focusText"
              [formatDetail]="formatDetailInput" (emitFormatDetail)="getFormatDetail($event)"
              (finishLoadingPrint)="finishLoading($event)">
            </app-print-subrental-output>
          </div>

          <!-- Formato Liquidación - Vista Previa -->
          <div *ngIf="formatLiquidation == formatModel().code">
            <app-preview-liquidation *ngIf="formatLiquidation == formatModel().code" id="printComponent"
              [hidden]="!finishLoadingPrint" [editFormat]="true" [companyId]="companyId" [formatModel]="formatModel()"
              [liquidationPrintModel]="liquidationPrintModel" [exportFormat]="exportFormat" [focusText]="focusText"
              [formatDetail]="formatDetailInput" (emitFormatDetail)="getFormatDetail($event)"
              (finishLoadingPrint)="finishLoading($event)"></app-preview-liquidation>
          </div>

          <!-- Formato Imprimir Ajuste Costos -->
          <app-print-cost-adjustment *ngIf="formatCostAdjustment == formatModel().code" id="preview-cost-adjustment"
            [reloadPrint]="reloadPrint" [companyId]="companyId" [formatModel]="formatModel()"
            [costAdjustmentPrintModel]="costAdjustmentPrintModel" [exportFormat]="exportFormat" [focusText]="focusText"
            [formatDetail]="formatDetailInput" [editFormat]="true" (emitFormatDetail)="getFormatDetail($event)">
          </app-print-cost-adjustment>

          <!-- Formato Imprimir Recibo de Caja -->
          <app-print-cash-receipt *ngIf="formatCashReceipt == formatModel().code" id="preview-cash-receipt"
            [companyId]="companyId" [cashReceiptModels]="cashReceiptModel" [exportFormat]="exportFormat"
            [focusText]="focusText" [formatDetail]="formatDetailInput" [editFormat]="true"
            (emitFormatDetail)="getFormatDetail($event)"></app-print-cash-receipt>

          <!-- Formato Imprimir Orden de Mantenimiento en Sitio -->
          <app-print-maintenance-order-site *ngIf="formatMaintenanceOrderSite == formatModel().code"
            id="preview-maintenance-order-site" [companyId]="companyId" [exportFormat]="exportFormat"
            [maintenanceOrderPrintModel]="maintenanceOrderSitePrintModel" [editFormat]="true" [focusText]="focusText"
            [reloadPrint]="reloadPrint" [formatDetail]="formatDetailInput" (emitFormatDetail)="getFormatDetail($event)">
          </app-print-maintenance-order-site>

          <!-- Formato Imprimir Orden de Mantenimiento en Taller -->
          <app-print-maintenance-order-workshop *ngIf="formatMaintenanceOrderWorkshop == formatModel().code"
            id="preview-maintenance-order-workshop" [companyId]="companyId" [exportFormat]="exportFormat"
            [maintenanceOrderPrintModel]="maintenanceOrderWorkshopPrintModel" [editFormat]="true"
            [focusText]="focusText" [reloadPrint]="reloadPrint" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-maintenance-order-workshop>

          <app-print-maintenance-order-scheduled *ngIf="formatMaintenanceOrderScheduled == formatModel().code"
            id="print-maintenance-order-scheduled" [companyId]="companyId" [formatModel]="formatModel()"
            [exportFormat]="exportFormat" [maintenanceOrderPrintContract]="maintenanceOrderScheduledPrintModel"
            [editFormat]="true" [focusText]="focusText" [reloadPrint]="reloadPrint" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-maintenance-order-scheduled>

          <!-- Formato Imprimir Orden de Mantenimiento Preventivo -->
          <app-print-maintenance-routine *ngIf="formatMaintenanceRoutine == formatModel().code"
            id="preview-maintenance-routine" [companyId]="companyId" [formatModel]="formatModel()"
            [exportFormat]="exportFormat" [maintenanceRoutinePrintContract]="maintenanceRoutinePrintModel"
            [editFormat]="true" [focusText]="focusText" [reloadPrint]="reloadPrint" [formatDetail]="formatDetailInput"
            (emitFormatDetail)="getFormatDetail($event)">
          </app-print-maintenance-routine>
        </div>
      </div>
    </div>
  </div>
</section>